import { dbAnotadorInstance } from "../database/db"
import { Document } from "../objects/Document.interface";
import { Project } from "../objects/Project.interface";

export const createNewProject = ():Project => {
    var _newProject:Project = {
      name: "",
      description: ""
    };
  
    return _newProject;
}

export class ProjectsService{
    constructor (){}

    getList(){
        const result = dbAnotadorInstance.projects.toArray();

        return result;
    }

    getProjectById(projectId: number){
        const result = dbAnotadorInstance.projects.where({id:projectId}).toArray();
        return result;
    }

    update(project: Project){
        const result = dbAnotadorInstance.projects.update(project.id!, project);
        return result;
    }

    add(project:Project){
        const result = dbAnotadorInstance.projects.add(project);
        return result;
    }
    delete(key:number)
    {

        const deleteAnnotations = dbAnotadorInstance.documents.where({projectId: key}).toArray().then(res =>{
                var documentList = res? (res as Document[]): ([] as Document[]);
                var documentsIds = documentList.map(item => item.id);

                const annotations = dbAnotadorInstance.annotations.toArray().then(annotationsResult =>{
                    var annotationsFilter =  annotationsResult.filter(item => documentsIds.includes(item.documentId));
                    var annotationsIds =  annotationsFilter.map(item => item.id!);

                    const deleteRecords = dbAnotadorInstance.annotations.bulkDelete(annotationsIds);
                    return annotationsResult;
                });

                return annotations;
        });
        const deleteEntities = dbAnotadorInstance.entities.where({projectId: key}).delete().then(res => {console.log(res);});
        const deleteDocuments = dbAnotadorInstance.documents.where({projectId: key}).delete().then(res => { console.log(res); });
          
        const result = dbAnotadorInstance.projects.delete(key);
        return result;
    }
}